import React from 'react';

const ConfidentialFolder = () => {
  return (
    <svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M26.7914 15.4383L26.9212 15.7413H27.2509H41.1423C43.6276 15.7413 45.6423 17.7561 45.6423 20.2413V37.7779C45.6423 40.2631 43.6276 42.2779 41.1423 42.2779H14C11.5147 42.2779 9.5 40.2631 9.5 37.7779V15.2413C9.5 14.2796 10.2796 13.5 11.2413 13.5H24.3122C25.3123 13.5 26.2161 14.096 26.61 15.0152L26.7914 15.4383Z'
        stroke='#2481C4'
      />
      <path
        d='M30.7741 26.448V24.2908C30.7741 22.6528 29.4839 21.325 27.8924 21.325C26.3008 21.325 25.0107 22.6528 25.0107 24.2908V26.448'
        stroke='#2481C4'
      />
      <mask id='mask0_2577:11689' maskUnits='userSpaceOnUse' x='23' y='25' width='10' height='11'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M32.6946 25.8079H23.0889V35.4136H32.6946V25.8079ZM27.8916 32.2122C28.7758 32.2122 29.4925 31.4954 29.4925 30.6112C29.4925 29.727 28.7758 29.0102 27.8916 29.0102C27.0074 29.0102 26.2906 29.727 26.2906 30.6112C26.2906 31.4954 27.0074 32.2122 27.8916 32.2122Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_2577:11689)'>
        <path
          d='M23.0889 25.8079V24.8079H22.0889V25.8079H23.0889ZM32.6946 25.8079H33.6946V24.8079H32.6946V25.8079ZM23.0889 35.4136H22.0889V36.4136H23.0889V35.4136ZM32.6946 35.4136V36.4136H33.6946V35.4136H32.6946ZM23.0889 26.8079H32.6946V24.8079H23.0889V26.8079ZM24.0889 35.4136V25.8079H22.0889V35.4136H24.0889ZM32.6946 34.4136H23.0889V36.4136H32.6946V34.4136ZM31.6946 25.8079V35.4136H33.6946V25.8079H31.6946ZM28.4925 30.6112C28.4925 30.9431 28.2235 31.2122 27.8916 31.2122V33.2122C29.328 33.2122 30.4925 32.0477 30.4925 30.6112H28.4925ZM27.8916 30.0102C28.2235 30.0102 28.4925 30.2793 28.4925 30.6112H30.4925C30.4925 29.1747 29.328 28.0102 27.8916 28.0102V30.0102ZM27.2906 30.6112C27.2906 30.2793 27.5597 30.0102 27.8916 30.0102V28.0102C26.4551 28.0102 25.2906 29.1747 25.2906 30.6112H27.2906ZM27.8916 31.2122C27.5597 31.2122 27.2906 30.9431 27.2906 30.6112H25.2906C25.2906 32.0477 26.4551 33.2122 27.8916 33.2122V31.2122Z'
          fill='#2481C4'
        />
      </g>
    </svg>
  );
};

ConfidentialFolder.displayName = 'ConfidentialFolder';

export default ConfidentialFolder;
